export const bonuses = [
  {
    num: '01',
    title: 'Kit de Adaptaciones Rápidas',
    desc: 'Versión A, B y C para cada ejercicio. La misma clase para grupos mixtos.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/uiThw6MmkhzjeK1izuU75Y/BONO_1.webp',
  },
  {
    num: '02',
    title: 'Banco de 20 Warm-Ups Listos',
    desc: 'Calentamientos específicos por tipo de sesión. Express y completos.',
    value: 'USD $8',
    image: 'https://cdn.magicpatterns.com/uploads/mznfrhWEab51iuJMDAVGxh/BONO_2.webp',
  },
  {
    num: '03',
    title: 'Banco de 20 Cool Downs y Cierres',
    desc: 'Termina cada clase con profesionalismo. Scripts de cierre incluidos.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/8BmieAD5enaNdNDJrabV5c/BONO_3.webp',
  },
  {
    num: '04',
    title: '50 Frases y Scripts de Coaching',
    desc: 'Las palabras exactas para motivar, corregir y liderar tu clase.',
    value: 'USD $7',
    image: 'https://cdn.magicpatterns.com/uploads/vtM6h2S7SiZGPcTo7Jag9s/BONO_4.webp',
  },
  {
    num: '05',
    title: 'Planilla Maestra del Sistema',
    desc: 'Vista anual, mensual, semanal y diaria. Sin improvisar.',
    value: 'USD $9',
    image: 'https://cdn.magicpatterns.com/uploads/eBSsoCAHqPctuYrAtz3Yxa/BONO_5.webp',
  },
]
